// Copyright (c) 2017 Deere & Company

import actions from '../../action-list';
import {getDefaultState} from '../state';

const updateSelectedStatus = (state, action) => action.status;

const resetSelectedStatus = () => getDefaultState().selectedStatus;

export default (state = getDefaultState().selectedStatus, action) => {

    const actionTypes = {
        [actions.RESET_CLAIMS_IN_PROGRESS]: resetSelectedStatus,
        [actions.UPDATE_CLAIMS_IN_PROGRESS_STATUS]: updateSelectedStatus
    };

    const reducer = actionTypes[action.type];

    return reducer ?
        reducer(state, action) :
        state;

};



// WEBPACK FOOTER //
// ./src/claim/claims-in-progress/reducers/selected-status.js